import React from 'react';
import { Box, Container, Toolbar, Button, Card, Alert, Slide } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import Grid2 from '@mui/material/Unstable_Grid2'
import LeftDrawer from './components/public/LeftDrawer'
import Appbar from './components/public/AppBar'
import Login from './pages/Login'
import Customers from './pages/Customers'
import Products_gacha_presell from './pages/Products_gacha_presell'
import Orders from './pages/Orders'
import customerTheme from './utils/customerTheme'
import Logistics from './pages/Logistics';
import Brands from './pages/Brands';
import Welcome from './pages/Welcome';
import CustomerTypes from './pages/CustomerTypes';
import ProductTags from './pages/ProductTags';
import { useCookies } from 'react-cookie'
import Products_goods_presell from './pages/Products_goods_presell';
import Products_figuare from './pages/Products_figuare';
import Dealers from './pages/Dealers';
import CustomCustomers from './pages/CustomCustomers';
import Products_goods_instock from './pages/Products_goods_instock';
import Jobs from './pages/Jobs';
import Products_special_presell from './pages/Products_special_presell';
import OfflineShops from './pages/OfflineShops';
import OrdersErp321 from './components/OnlineShop/OrdersErp321';
import Products_gacha_instock from './pages/Products_gacha_instock';
import Products_special_instock from './pages/Products_special_instock';
import Products_gacha_presell_and_instock from './pages/Products_gacha_presell_and_instock';
import Products_goods_presell_and_instock from './pages/Products_goods_presell_and_instock';
import Products_special_presell_and_instock from './pages/Products_special_presell_and_instock';
import FindProductByTaobaoId from './pages/FindProductsByTaobaoId';
import Products_blind_instock from './pages/Products_blind_instock';
import Products_hundred_yen_instock from './pages/Products_hundred_yen_instock';
import Products_ichibankuji_instock from './pages/Products_ichibankuji_instock';
import Animals from './pages/Animals';
import Animals_category from './pages/Animals_categorys';

function App() {
  const [tabs, setTabs] = React.useState<string[]>([])
  const [currentTab, setCurrentTab] = React.useState<string>(tabs[0])
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const [logined, setLogined] = React.useState(false)
  const [cookies, setCookie, removeCookie] = useCookies(['']);
  const [alertInfo, setAlertInfo] = React.useState({ show: false, severty: 'success', info: '' })
  const [reloadArg, setReloadArg] = React.useState(true)
  const newAlert = (info: string, severty?: 'error' | 'success' | 'info' | 'warning', consistent?: boolean) => {
    const hideAlert = () => {
      if ((alertInfo.severty === 'success' || alertInfo.severty === 'info' || alertInfo.severty === 'warning') && !consistent) {
        setTimeout(() => {
          alertInfo.show = false
          setAlertInfo(Object.assign({}, alertInfo))
        }, 1500);
      }
    }

    if (consistent === false) {
      alertInfo.show = false
      setAlertInfo(Object.assign({}, alertInfo))
    } else {
      if (alertInfo.show === false) {
        alertInfo.info = info
        alertInfo.severty = severty ? severty : 'success'
        alertInfo.show = true
        setAlertInfo(Object.assign({}, alertInfo))
        hideAlert()
      } else {
        if (!consistent) {
          alertInfo.show = false
        }
        // setAlertInfo(Object.assign({}, alertInfo))
        setTimeout(() => {
          alertInfo.info = info
          alertInfo.severty = severty ? severty : 'success'
          alertInfo.show = true
          setAlertInfo(Object.assign({}, alertInfo))
          hideAlert()
        }, consistent ? 0 : 200);
      }
    }
  }

  const reload = () => {
    console.log("refresh!")
    setReloadArg(!reloadArg)
  }

  React.useEffect(() => {
    if (logined) {
      // let tabsTemp = (window as any).user_level == 2 ? ['订单列表（海关）', '客户列表（海关）', '退出登录'] : (window as any).user_level ? ['订单统计', '商品列表（扭蛋）', '商品列表（周边）', '商品列表（周边-现货）', '商品列表（手办）', '工单列表', '订单列表（扭蛋）', '订单列表（周边）', '订单列表（周边-现货）', '订单列表（手办）', '订单列表（海关）', '客户列表', '客户分类', '客户列表（海关）', '经销分类', '快递列表', '品牌列表', '标签列表', '退出登录'] : []
      let tabsTemp: any[] = []
      if ((window as any).user_level) {
        tabsTemp = ['订单统计',
          '店铺统计',
          '商品列表（扭蛋-预售）',
          '商品列表（扭蛋-现货）',
          '商品列表（扭蛋-预售+现货）',
          '商品列表（周边-预售）',
          '商品列表（周边-现货）',
          '商品列表（周边-预售+现货）',
          '商品列表（百元包-现货）',
          '商品列表（盲盒-现货）',
          '商品列表（一番赏-现货）',
          '商品列表（特许-预售）',
          '商品列表（特许-现货）',
          '商品列表（特许-预售+现货）',
          '商品列表（手办）',
          '商品列表（动物-分类）',
          '商品列表（爬宠-预售）',
          '商品列表（蜥蜴-现货）',
          '商品列表（守宫-现货）',
          '商品列表（蛇-现货）',
          '商品列表（两栖-现货）',
          '商品列表（昆虫-现货）',
          '商品列表（鱼-现货）',
          '商品列表（哺乳动物-现货）',
          '商品列表（玩具-现货）',
          '商品列表（器材-现货）',
          '工单列表',
          '订单列表（扭蛋）',
          '订单列表（周边）',
          '订单列表（商城）',
          '订单列表（手办）',
          '订单列表（海关）',
          '客户列表',
          '结算（根据款式编码查商品）',
          '客户分类',
          '客户列表（海关）',
          '经销分类',
          '快递列表',
          '品牌列表',
          '标签列表',
          '速卖通录入',
          '退出登录'
        ]
      }

      if ((window as any).user_level == 3) {
        tabsTemp = ['商品列表（扭蛋-预售）',
          '商品列表（扭蛋-现货）',
          '商品列表（扭蛋-预售+现货）',
          '商品列表（周边-预售）',
          '商品列表（周边-现货）',
          '商品列表（周边-预售+现货）',
          '商品列表（百元包-现货）',
          '商品列表（盲盒-现货）',
          '商品列表（一番赏-现货）',
          '品牌列表',
          '退出登录'
        ]
      }
      if ((window as any).user_level == 4) {
        tabsTemp = [
          '商品列表（盲盒-现货）',
          '品牌列表',
          '退出登录'
        ]
      }
      if ((window as any).user_level == 5) {
        tabsTemp = [
          '商品列表（动物-分类）',
          '商品列表（蜥蜴-现货）',
          '商品列表（守宫-现货）',
          '商品列表（蛇-现货）',
          '商品列表（两栖-现货）',
          '商品列表（昆虫-现货）',
          '商品列表（鱼-现货）',
          '商品列表（哺乳动物-现货）',
          '商品列表（玩具-现货）',
          '商品列表（器材-现货）',
          '退出登录'
        ]
      }
      setTabs(tabsTemp)
      setCurrentTab(tabsTemp[0])
    }
  },
    [logined])

  return (
    <ThemeProvider theme={customerTheme}>
      <Appbar
        toggleDrawer={() => setDrawerOpen(!drawerOpen)}
        reload={reload}
        currentTab={currentTab}
      >
      </Appbar>
      <LeftDrawer
        open={drawerOpen}
        tabs={tabs}
        onClose={() => setDrawerOpen(false)}
        onChosen={(index: number) =>
          () => {
            if (tabs[index] == '退出登录') {
              removeCookie("JWT" as any)
              setLogined(false)
              setCurrentTab(tabs[0])
              setDrawerOpen(false)
              alertInfo.show = false;
              (window as any).user_level = undefined
            } else {
              setCurrentTab(tabs[index])
              setDrawerOpen(false)
              alertInfo.show = false
            }
          }
        }
      />
      {
        <Box
          sx={{ height: 0, width: '100%', maxWidth: '100%', position: "fixed", zIndex: 2100, top: 0, display: 'flex', justifyContent: 'center' }}
        >
          <Slide
            in={alertInfo.show}
          >
            <Alert
              sx={{ height: '40px' }}
              severity={alertInfo.severty as any}
              onClose={alertInfo.severty === 'success' ? undefined : () => {
                alertInfo.show = !alertInfo.show
                setAlertInfo(Object.assign({}, alertInfo))
              }}
            >
              {alertInfo.info}
            </Alert>
          </Slide >
        </Box>
      }
      <Box>
        <Toolbar />
        <Container
          maxWidth='sm'
        >
          {!logined &&
            <Login logined={logined} setLogined={setLogined}></Login>
          }
        </Container>

        <Grid2
          container
        >
          <Grid2
            xs={12}
            sx={{ m: 2 }}
          >
            <Box
            >
              {
                logined && currentTab === '订单统计' &&
                <Welcome
                  newAlert={newAlert}
                ></Welcome>
              }

              {
                logined && currentTab === '店铺统计' &&
                <OfflineShops
                  newAlert={newAlert}
                ></OfflineShops>
              }

              {
                logined && currentTab === '商品列表（扭蛋-预售）' &&
                <Products_gacha_presell
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_gacha_presell>
              }
              {
                logined && currentTab === '商品列表（扭蛋-现货）' &&
                <Products_gacha_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_gacha_instock>
              }
              {
                logined && currentTab === '商品列表（扭蛋-预售+现货）' &&
                <Products_gacha_presell_and_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_gacha_presell_and_instock>
              }
              {
                logined && currentTab === '商品列表（周边-预售）' &&
                <Products_goods_presell
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_goods_presell>
              }

              {
                logined && currentTab === '商品列表（周边-现货）' &&
                <Products_goods_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_goods_instock>
              }
              {
                logined && currentTab === '商品列表（周边-预售+现货）' &&
                <Products_goods_presell_and_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_goods_presell_and_instock>
              }
              {
                logined && currentTab === '商品列表（百元包-现货）' &&
                <Products_hundred_yen_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_hundred_yen_instock>
              }
              {
                logined && currentTab === '商品列表（盲盒-现货）' &&
                <Products_blind_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_blind_instock>
              }
              {
                logined && currentTab === '商品列表（一番赏-现货）' &&
                <Products_ichibankuji_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_ichibankuji_instock>
              }
              {
                logined && currentTab === '商品列表（特许-预售）' &&
                <Products_special_presell
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_special_presell>
              }
              {
                logined && currentTab === '商品列表（特许-现货）' &&
                <Products_special_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_special_instock>
              }
              {
                logined && currentTab === '商品列表（特许-预售+现货）' &&
                <Products_special_presell_and_instock
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_special_presell_and_instock>
              }
              {
                logined && currentTab === '商品列表（手办）' &&
                <Products_figuare
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_figuare>
              }
              {
                logined && currentTab === '商品列表（海关）' &&
                <Products_figuare
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Products_figuare>
              }
              {
                logined && currentTab === '商品列表（动物-分类）' &&
                <Animals_category
                  animal_category="动物-分类"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals_category>
              }

              {
                logined && currentTab === '商品列表（爬宠-预售）' &&
                <Animals
                  animal_category="爬宠-预售"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（蜥蜴-现货）' &&
                <Animals
                  animal_category="蜥蜴-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（守宫-现货）' &&
                <Animals
                  animal_category="守宫-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（蛇-现货）' &&
                <Animals
                  animal_category="蛇-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（两栖-现货）' &&
                <Animals
                  animal_category="两栖-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（昆虫-现货）' &&
                <Animals
                  animal_category="昆虫-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（鱼-现货）' &&
                <Animals
                  animal_category="鱼-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（哺乳动物-现货）' &&
                <Animals
                  animal_category="哺乳动物-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（玩具-现货）' &&
                <Animals
                  animal_category="玩具-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '商品列表（器材-现货）' &&
                <Animals
                  animal_category="器材-现货"
                  newAlert={newAlert}
                  reloadArg={reloadArg}
                ></Animals>
              }
              {
                logined && currentTab === '工单列表' &&
                <Jobs
                  newAlert={newAlert}
                ></Jobs>
              }

              {
                logined && currentTab === '客户列表' &&
                <Customers
                  newAlert={newAlert}
                ></Customers>
              }
              {
                logined && currentTab === '客户分类' &&
                <CustomerTypes
                  newAlert={newAlert}
                ></CustomerTypes>
              }
              {
                logined && currentTab === '结算（根据款式编码查商品）' &&
                <FindProductByTaobaoId
                  newAlert={newAlert}
                ></FindProductByTaobaoId>
              }
              {
                logined && currentTab === '客户列表（海关）' &&
                <CustomCustomers
                  newAlert={newAlert}
                ></CustomCustomers>
              }
              {
                logined && currentTab === '经销分类' &&
                <Dealers
                  newAlert={newAlert}
                ></Dealers>
              }
              {
                logined && currentTab === '订单列表（扭蛋）' &&
                <Orders
                  newAlert={newAlert}
                  category="扭蛋"
                  reloadArg={reloadArg}
                ></Orders>
              }
              {
                logined && currentTab === '订单列表（周边）' &&
                <Orders
                  newAlert={newAlert}
                  category="周边"
                  reloadArg={reloadArg}
                ></Orders>
              }
              {
                logined && currentTab === '订单列表（商城）' &&
                <Orders
                  newAlert={newAlert}
                  category="商城"
                  reloadArg={reloadArg}
                ></Orders>
              }
              {/* {
                logined && currentTab === '订单列表（周边-现货）' &&
                <Orders
                  newAlert={newAlert}
                  category="周边-现货"
                  reloadArg={reloadArg}
                ></Orders>
              } */}
              {
                logined && currentTab === '订单列表（手办）' &&
                <Orders
                  newAlert={newAlert}
                  category="手办"
                  reloadArg={reloadArg}
                ></Orders>
              }

              {
                logined && currentTab === '订单列表（海关）' &&
                <Orders
                  newAlert={newAlert}
                  category="海关"
                  reloadArg={reloadArg}
                ></Orders>
              }

              {
                logined && currentTab === '快递列表' &&
                <Logistics
                  newAlert={newAlert}
                ></Logistics>
              }

              {
                logined && currentTab === '品牌列表' &&
                <Brands
                  newAlert={newAlert}
                ></Brands>
              }
              {
                logined && currentTab === '标签列表' &&
                <ProductTags
                  newAlert={newAlert}
                ></ProductTags>
              }
              {
                logined && currentTab === '速卖通录入' &&
                <OrdersErp321
                  newAlert={newAlert}
                ></OrdersErp321>
              }
            </Box>
          </Grid2>
        </Grid2>

      </Box>
    </ThemeProvider>
  );
}

export default App;